/**
 * PATH: apps/qa/src/pages/reports/StandardReports.tsx
 * FILE_ID: QA-REPORTS-STANDARD-001
 * PURPOSE: The standard reports an operator can generate from the Reports page.
 * WHY: The page crashed, and the report types were hidden inside one dialog.
 * DEPENDENCIES: STANDARD_REPORTS in report-helpers.ts
 */

import { STANDARD_REPORTS } from './report-helpers'

export function StandardReports({ onGenerate }: { onGenerate: (reportType: string) => void }) {
  return (
    <section aria-label="Standard reports" className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3">
      {STANDARD_REPORTS.map((report) => (
        <article key={report.value} className="flex flex-col rounded-xl border border-border bg-card p-4">
          <h2 className="text-sm font-semibold text-foreground">{report.label}</h2>
          <p className="mt-1 flex-1 text-sm text-muted-foreground">{report.detail}</p>
          <button
            type="button"
            onClick={() => onGenerate(report.value)}
            className="mt-3 inline-flex w-fit items-center rounded-lg bg-primary px-3 py-1.5 text-sm font-medium text-primary-foreground hover:bg-primary/90"
          >
            Generate {report.label}
          </button>
        </article>
      ))}
    </section>
  )
}
